import React from 'react';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';

class SettingLetter extends React.Component {
  render() {
    const {
      input,
      meta,
      type,
      placeholder,
      readOnly,
      maxLength,
      dis = false,
      inputClassName,
      feedbackClassName,
      prefixText,
      prefixTextClassName,
      prefixTextClassNameError,
    } = this.props;
    const { touched, error } = meta;
    return (
      <div
        className={
          touched
            ? error
              ? 'has-feedback has-error'
              : 'has-feedback has-success'
            : ''
        }
      >
        {prefixText && (
          <div
            className={
              touched
                ? error
                  ? prefixTextClassNameError
                  : prefixTextClassName
                : prefixTextClassName
            }
          >
            {prefixText}
          </div>
        )}
        <input
          {...input}
          type={type}
          readOnly={readOnly}
          maxLength={maxLength}
          className={`form-control ${inputClassName}`}
          placeholder={placeholder}
          onKeyPress={this._onKeyPress}
          disabled={dis}
        />
        {touched ? (
          error ? (
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="tooltip">{error}</Tooltip>}
            >
              <span
                className={`form-control-feedback glyphicon glyphicon-remove ${feedbackClassName}`}
                style={{ 'pointer-events': 'auto', cursor: 'pointer' }}
              />
            </OverlayTrigger>
          ) : (
            <span
              className={`form-control-feedback glyphicon glyphicon-ok ${feedbackClassName}`}
            />
          )
        ) : (
          ''
        )}
      </div>
    );
  }

  _onKeyPress = e => {
    const letterOnly = this.props;
    // allow letters only
    if (letterOnly) {
      const letterRegex = /^[a-zA-Z\s]*$/;
      if (!letterRegex.test(e.key)) {
        e.preventDefault();
      }
    }
  };
}

export default SettingLetter;
